<p-dialog
  header="Art-in-Coffee Token"
  [(visible)]="visible"
  [modal]="true"
  [closable]="true"
  [dismissableMask]="true"
  [style]="{ width: '500px' }"
  (onHide)="onDialogHide()"
>
  <div class="aic-token-content" style="position: relative; min-height: 100px;">
    <div *ngIf="loading" class="loading-overlay">
      <p-progressSpinner
        styleClass="custom-spinner"
        strokeWidth="4"
        fill="#eeeeee"
        animationDuration="1s"
        [style]="{ width: '40px', height: '40px' }"
      ></p-progressSpinner>
    </div>

    <div *ngIf="errorMessage" class="error-message">
      <i class="pi pi-exclamation-triangle"></i>
      <span>{{ errorMessage }}</span>
    </div>

    <div *ngIf="!loading" class="token-form">
      <label for="aic-token-input" class="token-label">Token</label>
      <input
        id="aic-token-input"
        type="text"
        pInputText
        [(ngModel)]="token"
        placeholder="Enter your Art-in-Coffee token"
        class="token-input"
        [disabled]="saving"
      />
    </div>
  </div>

  <ng-template #footer>
    <div class="dialog-footer">
      <p-button
        label="Cancel"
        icon="pi pi-times"
        [outlined]="true"
        severity="secondary"
        (onClick)="close()"
        [disabled]="saving"
      ></p-button>
      <p-button
        label="Save"
        icon="pi pi-check"
        (onClick)="saveToken()"
        [disabled]="saving || loading"
        [loading]="saving"
      ></p-button>
    </div>
  </ng-template>
</p-dialog>
<p-toast position="bottom-center"></p-toast>
